module.exports = __webpack_public_path__ + "static/media/actual_sob.1241ad71.xlsx";